(() => {
  function initialize(root) {
    if (!root || root.dataset.btInitialized) return;
    root.dataset.btInitialized = 'true';
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      gallery.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
        const image = gallery.querySelector('[data-gallery-main]');
        image.src = button.dataset.image;
        image.alt = button.dataset.alt || '';
        const caption = gallery.querySelector('[data-gallery-caption]');
        if (caption) caption.textContent = button.dataset.caption || '';
        gallery.querySelectorAll('[data-image]').forEach(other => {
          other.classList.toggle('selected', other === button);
          other.setAttribute('aria-pressed', String(other === button));
        });
      }));
    });
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    function selectTab(tab) {
      tabs.forEach(other => {
        const active = other === tab;
        other.setAttribute('aria-selected', String(active));
        other.tabIndex = active ? 0 : -1;
        root.querySelector('#' + other.getAttribute('aria-controls')).hidden = !active;
      });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); selectTab(tabs[next]); tabs[next].focus();
      });
    });
    const select = root.querySelector('[data-bt-variant]');
    if (select) select.addEventListener('change', () => {
      const variant = select.selectedOptions[0].dataset;
      const sale = variant.sale === 'true';
      const limited = root.dataset.limitedTime === 'true';
      root.querySelector('[data-bt-price]').textContent = variant.price;
      const compare = root.querySelector('[data-bt-compare]');
      compare.textContent = variant.compare; compare.hidden = !sale;
      const badge = root.querySelector('[data-bt-sale]');
      badge.textContent = 'SAVE ' + variant.percent + '%'; badge.hidden = !sale;
      const savings = root.querySelector('[data-bt-savings]');
      savings.textContent = (limited ? 'Limited-time offer · ' : '') + 'Save ' + variant.savings; savings.hidden = !sale;
      root.querySelectorAll('[data-bt-cta]').forEach(node => node.textContent = sale ? 'Get the kit — ' + variant.percent + '% off' : 'Get your kit');
      root.querySelector('[data-bt-offer-headline]').textContent = sale ? 'Get your kit for ' + variant.percent + '% off.' : 'Get your complete kit.';
      root.querySelector('[data-bt-promo]').textContent = sale ? (limited ? 'LIMITED-TIME OFFER · ' : '') + 'SAVE ' + variant.percent + '% ON ONE COMPLETE KIT' : 'ONE COMPLETE KIT · BT CHASSIS CLEANER';
      const buy = root.querySelector('[data-bt-buy]');
      buy.disabled = variant.available !== 'true';
      buy.textContent = buy.disabled ? 'Sold out' : 'Get one kit · ' + variant.price;
      const note = root.querySelector('.cta-note');
      if (note) note.textContent = 'One complete kit.' + (limited && sale ? ' Limited-time offer.' : '');
    });
    const bar = root.querySelector('.mobile-buy');
    const offer = root.querySelector('.offer');
    if (bar && offer && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => bar.classList.toggle('offer-visible', entries[0].isIntersecting), {threshold: .1});
      observer.observe(offer);
      root.btOfferObserver = observer;
    }
    // Product form submits natively to Shopify, with quantity=1 and a checkout redirect.
    // No local/cart simulation and no interception of the purchase submission.
  }
  document.querySelectorAll('[data-bt-landing]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-bt-landing]')));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-bt-landing]')?.btOfferObserver?.disconnect());
})();
